/*
 * PBN Menu align (desktop)
 * Horizon opens every mega menu panel at the left edge of the page. For items on the right
 * (Help, Supplies, Holidays & Gifts) shoppers have to move the mouse all the way across the
 * screen. This script moves the panel content so it sits centered under the hovered menu
 * item, clamped to the page edges. Wide panels move only as far as the page allows.
 * Layout is untouched; only the CSS `translate` of the list is set.
 */
(function () {
  if (window.__pbnMenuAlign) return;
  window.__pbnMenuAlign = true;

  var mq = window.matchMedia('(min-width: 990px)');
  var EDGE = 16;

  function contentBox(list) {
    var hasImages = !!list.querySelector('.mega-menu__link-image');
    // Image panels: whole link rows (thumbnail + text). Text panels: just the words.
    var nodes = list.querySelectorAll(hasImages ? '.mega-menu__link' : '.wrap-text');
    var left = Infinity;
    var right = -Infinity;
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (!r.width) continue;
      if (r.left < left) left = r.left;
      if (r.right > right) right = r.right;
    }
    if (left === Infinity) return null;
    return { left: left, right: right, width: right - left };
  }

  function align(item) {
    if (!mq.matches || !item) return;
    var list = item.querySelector('.mega-menu__list');
    var trigger = item.querySelector('.menu-list__link') || item;
    if (!list) return;

    list.style.translate = '';
    var box = contentBox(list);
    if (!box || !box.width) return;

    var t = trigger.getBoundingClientRect();
    var viewport = document.documentElement.clientWidth;
    var desired = t.left + t.width / 2 - box.width / 2;
    var minLeft = EDGE;
    var maxLeft = viewport - EDGE - box.width;
    if (maxLeft < minLeft) maxLeft = minLeft;
    desired = Math.max(minLeft, Math.min(desired, maxLeft));

    var shift = Math.round(desired - box.left);
    if (Math.abs(shift) > 2) list.style.translate = shift + 'px 0';
  }

  function schedule(item) {
    if (!item) return;
    requestAnimationFrame(function () { align(item); });
    setTimeout(function () { align(item); }, 80);
    setTimeout(function () { align(item); }, 260);
  }

  function itemFrom(target) {
    return target && target.closest ? target.closest('.menu-list__list-item') : null;
  }

  var last = null;
  document.addEventListener('pointerover', function (e) {
    var item = itemFrom(e.target);
    if (!item || item === last) return;
    last = item;
    schedule(item);
  }, { passive: true });

  document.addEventListener('pointerout', function (e) {
    var item = itemFrom(e.target);
    if (item && !item.contains(e.relatedTarget)) last = null;
  }, { passive: true });

  document.addEventListener('focusin', function (e) {
    schedule(itemFrom(e.target));
  });

  document.addEventListener('click', function (e) {
    schedule(itemFrom(e.target));
  });

  // Keyboard / script openings: react when Horizon flips aria-expanded
  var observer = new MutationObserver(function (records) {
    records.forEach(function (r) {
      if (r.target.getAttribute('aria-expanded') === 'true') schedule(itemFrom(r.target));
    });
  });
  function observe() {
    document.querySelectorAll('.menu-list__list-item [aria-expanded]').forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['aria-expanded'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();

  window.addEventListener('resize', function () {
    document.querySelectorAll('.mega-menu__list').forEach(function (l) { l.style.translate = ''; });
    last = null;
  }, { passive: true });
})();
